import React from 'react'
import { Form, Container, Table, TableRow, TableBody, TableCell, TableHeader, TableHeaderCell} from 'semantic-ui-react'
import { useFormik } from 'formik'
import { initialValues, validationSchema3 } from './OpeForm.form'
import { DZ } from '../../../../../api'
import { useAuth } from '../../../../../hooks'
import "./OpeForm.scss";

const DZController = new DZ();

export function OpeDZForm3(props) {
    const { onClose, onReload, DZ } = props;
    const { accessToken } = useAuth();

    const formik = useFormik({
        initialValues: initialValues(DZ),
        validationSchema: validationSchema3(),
        validateOnChange: false,
        onSubmit: async (formValue) => {
            try {
                const data = {
                  codigo : formValue.codigo,
                  sOpe3: true,
                }
                if (!DZ) {
                    console.log("no deberia de pasar")
                   
                    // await equalController.createDZ(accessToken, data);
                } else {
                    await DZController.UpdateOpe(accessToken, DZ._id, data);
                }
                onClose();
                onReload();
            } catch (error) {
                console.error(error);
            }
        }
    });

    
    const handleSave = async () => {
        try {
            const data = {
                codigo : formik.values.codigo
            }
            console.log(formik.values.codigo);
            await DZController.saveDZOpe(accessToken, DZ._id, data)
            onClose();
            onReload();
            } catch (error) {
            console.error(error);
        }
    }

    return (
        <Form onSubmit={formik.handleSubmit} className='form'>
            <Container className='cotizacion-principal_info'>
              <p>Asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesornom}</span></p>
              <p>Correo asesor: <span className='cotizacion-principal_info-dxp'>{DZ.asesor}</span></p>
              <br></br>
              {DZ.nombreoficial && <p>Nombre del producto: <span className='cotizacion-principal_info-nombre'>{DZ.nombreoficial}</span></p>}
              <p>Nombre del producto:<span className='cotizacion-principal_info-dxp'>{DZ.nombre}</span></p>
              <p>Familia del producto:<span className='cotizacion-principal_info-dxp'>{DZ.familia}</span></p>
              <p>Activos: <span className='cotizacion-principal_info-dxp'>{DZ.activos}</span></p>
              <p>Base: <span className='cotizacion-principal_info-base'>{DZ.base}</span></p>
              <p>Presentación: <span className='cotizacion-principal_info-activos'>{DZ.presentacion}</span></p>
              <p>Envase: <span className='cotizacion-principal_info-activos'>{DZ.envase}</span></p>
              <p>Área: <span className='cotizacion-principal_info-dxp'>{DZ.area}</span></p>
              {(DZ.sIyD && DZ.caducidad) && <p>Caducidad: <span className='cotizacion-principal_info-nombre'>{DZ.caducidad}</span></p>}
              <br></br>
              <p>Genero del paciente: <span className='cotizacion-principal_info-base'>{DZ.genero}</span></p>
              <p>Rango de edad: <span className='cotizacion-principal_info-dxp'>{DZ.rangoedad}</span></p>
              <p>Tipo de piel: <span className='cotizacion-principal_info-dxp'>{DZ.tipopiel}</span></p>
              <p>Padecimiento: <span className='cotizacion-principal_info-dxp'>{DZ.padecimiento}</span></p>

              <br></br>
              <p>Precio Objetivo: <span className='cotizacion-principal_info-activos'>{DZ.objetivo}</span></p>
              {DZ.motivo && <p>Motivo de cancelación: <span className='cotizacion-principal_info-nombre'>{DZ.motivo}</span></p>}
              {DZ.presupuesto && <p>Presupuesto por KG de InyDe: <span className='cotizacion-principal_info-nombre'>{DZ.presupuesto}</span></p>}
              {DZ.costologrado && <p>Presupuesto por KG Logrado: <span className='cotizacion-principal_info-nombre'>{DZ.costologrado}</span></p>}
              {DZ.preciounitario && <p>Precio Unitario: <span className='cotizacion-principal_info-nombre'>{DZ.preciounitario}</span></p>}
            </Container>
            <Form.Input label="Código de Formula DZ" name="codigo" placeholder="Código de la Formula DZ" onChange={formik.handleChange} value={formik.values.codigo} error={formik.errors.codigo} />
            <br></br>
            <Form.Button type='button' primary fluid onClick={handleSave} loading={formik.isSubmitting}>
                Guardar
            </Form.Button>
            <Form.Button type='submit' primary fluid loading={formik.isSubmitting}>
                Aceptar
            </Form.Button>
        </Form>
    )
}
